import { render, staticRenderFns } from "./CheckboxArrayValue.vue?vue&type=template&id=a2fd1c16&"
import script from "./CheckboxArrayValue.vue?vue&type=script&lang=js&"
export * from "./CheckboxArrayValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports